import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getInstitutionalInformation: ['campus', 'career', 'zona'],
  getInstitutionalInformationClear: null,
  getInstitutionalInformationRequest: null,
  getInstitutionalInformationSuccess: null,
  getInstitutionalInformationFailure: ['error']
});

export { Creators, Types };
